(function () {
    'use strict';

    function LocationInfoComponentController($scope, $state, PersonInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, SelectorData, SelectorDataQuery) {
        //
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.selectedId = '';
        $ctrl.country_changed = country_changed;
        $ctrl.province_changed = province_changed;
        $ctrl.selectordata = SelectorData.query();
        $ctrl.countryList = SelectorDataQuery.findByType('country').query();

        $ctrl.provinceList = [];
        $ctrl.cityList = [];
        $ctrl.getCurrentLocation = getCurrentLocation;

        $ctrl.markerDragEnd = markerDragEnd;

        $ctrl.positions = [
            {pos: [35.71, 50.21]},
        ];

        $ctrl.map = null;
        $ctrl.mapMarker = null;

        loadAll();

        loadPage();

        // loadMapBox();
        loadLeafletMap();


        function loadAll() {

            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('locationInfo');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();


            // loadSavedLocation();

            if ($ctrl.locationInfo == null || $ctrl.locationInfo == undefined) {
                $ctrl.locationInfo = {};
            }
            if ($ctrl.locationInfo != undefined && $ctrl.locationInfo.countryId != null && $ctrl.locationInfo.countryId != undefined) {
                $ctrl.provinceList = SelectorDataQuery.findByTypeAndParent('province', $ctrl.locationInfo.countryId).query();
                if ($ctrl.locationInfo.stateId != null && $ctrl.locationInfo.stateId != undefined) {
                    $ctrl.cityList = SelectorDataQuery.findByTypeAndParent('city', $ctrl.locationInfo.stateId).query();
                }


            }

        }

        function country_changed() {
            console.log($ctrl.countryList);
            console.log($ctrl.provinceList);
            $ctrl.provinceList = SelectorDataQuery.findByTypeAndParent('province', $ctrl.locationInfo.countryId).query();
        }

        function province_changed() {
            $ctrl.cityList = SelectorDataQuery.findByTypeAndParent('city', $ctrl.locationInfo.stateId).query();
        }


        function getCurrentLocation() {

            if (navigator.geolocation) {

                var options = {
                    enableHighAccuracy: true,
                    maximumAge: 0
                };

                navigator.geolocation.getCurrentPosition(success, error, options);
            } else {
                x.innerHTML = "Geolocation is not supported by this browser.";
            }
        }

        function success(pos) {
            var crd = pos.coords;

            $ctrl.locationInfo.mapX = crd.latitude;
            $ctrl.locationInfo.mapY = crd.longitude;

            showLeafletMap($ctrl.locationInfo.mapX, $ctrl.locationInfo.mapY);
            $ctrl.positions = [
                {pos: [$ctrl.locationInfo.mapX, $ctrl.locationInfo.mapY]}
            ];
        }

        function error(err) {

            console.warn(err.message);
        }


        // function loadSavedLocation()
        // {
        //     if($ctrl.locationInfo != null &&$ctrl.locationInfo != undefined) {
        //         if ($ctrl.locationInfo.mapX != null && $ctrl.locationInfo.mapX != undefined && $ctrl.locationInfo.mapY != null && $ctrl.locationInfo.mapY != undefined) {
        //             $ctrl.positions = [
        //                 {pos: [$ctrl.locationInfo.mapX, $ctrl.locationInfo.mapY]}
        //             ];
        //             return;
        //         }
        //     }
        //
        //     getCurrentLocation();
        // }

        function markerDragEnd(position) {

            $ctrl.locationInfo.mapX = position.latLng.lat();
            $ctrl.locationInfo.mapY = position.latLng.lng();

        }

        function loadMapBox() {


            setTimeout(function () {

                // L.Icon.Default.imagePath = '';
                var mapX;
                var mapY;
                var mymap;
                var initZoom = 16;

                // mapboxgl.accessToken = 'pk.eyJ1IjoibWptYWppZGYiLCJhIjoiY2tjNGpzcWFzMDhpOTJxbnU1OTk1ZjQyZyJ9.pWVBFzPmuog2zlf1MD2ubg';
                mapboxgl.accessToken = 'pk.eyJ1IjoibWotbWFqaWQtZmF0dGFoaSIsImEiOiJja3U1YjN3djUwNjE5MnFwYXZzcm1tczJhIn0.FLWOyjGqBEh9C5CT3gNyyQ';

                mapboxgl.setRTLTextPlugin(
                    'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
                    null,
                    true // Lazy load the plugin
                );

                if ($ctrl.locationInfo.mapX && $ctrl.locationInfo.mapY) {
                    mapX = $ctrl.locationInfo.mapX;
                    mapY = $ctrl.locationInfo.mapY;
                    //   mymap = L.map('mapid').setView([mapX, mapY], 15);
                } else {
                    mapX = 35.69439;
                    mapY = 51.42151;
                    //    mymap = L.map('mapid').setView([mapX, mapY], 13);
                }
                mymap = new mapboxgl.Map({
                    container: 'mapid',
                    style: 'mapbox://styles/mapbox/streets-v11',
                    center: [mapY, mapX], // starting position
                    zoom: initZoom // starting zoom
                });


                // L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
                //     // attribution: 'Mapسامانه نوبت دهی و رزرو آنلاین data &copy; <a href="https://www.reserweb.ir/">رزروب</a>',
                //     attribution: 'سامانه نوبت دهی و رزرو آنلاین &copy; <a style="font-weight: bold;" href="https://www.reserweb.ir/">رزروب</a>',
                //     maxZoom: 18,
                //     // id: 'mapbox.streets',
                //     // accessToken: 'your.mapbox.access.token'
                //     id: 'rakshak.l937n12c',
                //     accessToken: 'pk.eyJ1IjoicmFrc2hhayIsImEiOiJ5cHhqeHlRIn0.Vi87VjI1cKbl1lhOn95Lpw'
                // }).addTo(mymap);
                // if (!L.Icon.Default.imagePath) {
                var defaultIcon = L.icon({
                    iconUrl: '../../../bower_components/leaflet/dist/images/marker-icon-2x.png',
                    shadowUrl: '../../../bower_components/leaflet/dist/images/marker-shadow.png',

                    iconSize: [25, 41], // size of the icon
                    shadowSize: [41, 41], // size of the shadow
                    iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
                    shadowAnchor: [12, 41],  // the same for the shadow
                    popupAnchor: [-3, -76] // point from which the popup should open relative to the iconAnchor
                });
                // }
                mymap.addControl(
                    new mapboxgl.GeolocateControl({
                        positionOptions: {
                            enableHighAccuracy: true
                        },
                        trackUserLocation: true
                    })
                );
                var marker = new mapboxgl.Marker({draggable: true})
                    .setLngLat([mapY, mapX])
                    .addTo(mymap);

                // var marker = L.marker([mapX, mapY], {
                //     title: 'موقعیت ثبت شده کنونی',
                //     draggable: true,
                //     icon: defaultIcon
                // }).addTo(mymap);

                marker.on('dragend', function (m) {
                    // get and display lanLng of the marker while dragging
                    var coordinate = marker.getLngLat();

                    $ctrl.locationInfo.mapX = coordinate.lat;
                    $ctrl.locationInfo.mapY = coordinate.lng;

                });
            }, 1000);
        }

        function loadLeafletMap() {


            setTimeout(function () {

                var mapX;
                var mapY;

                L.Icon.Default.imagePath = '../bower_components/leaflet/dist/images';

                if ($ctrl.locationInfo.mapX && $ctrl.locationInfo.mapY) {
                    mapX = $ctrl.locationInfo.mapX;
                    mapY = $ctrl.locationInfo.mapY;
                } else {
                    mapX = 35.69439;
                    mapY = 51.42151;
                }

                $ctrl.map = L.map('mapid').setView([mapX, mapY], 13);

                $ctrl.map.addEventListener("click", function (event) {
                    setMarker(event.latlng.lat, event.latlng.lng)
                })

                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="https://www.planovin.com">Planovin</a>'
                }).addTo($ctrl.map);

                showLeafletMap(mapX, mapY);

            }, 1000);
        }

        function showLeafletMap(lat, lng) {

            if ($ctrl.map) {
                $ctrl.map.setView([lat, lng], 13);

                setMarker(lat, lng)


            }
        }

        function setMarker(lat, lng) {
            if ($ctrl.mapMarker)
                $ctrl.map.removeLayer($ctrl.mapMarker);
            // $ctrl.mapMarker = L.marker([lat, lng]).addTo($ctrl.map);


            $ctrl.mapMarker = L.marker([lat, lng], {title: "موقعیت کسب و کار", draggable: true})
                .addTo($ctrl.map)
                .on('dragend', function () {
                    var coord = $ctrl.mapMarker.getLatLng();
                    var lat = coord.lat;
                    var lng = coord.lng;

                    $ctrl.locationInfo.mapX = lat;
                    $ctrl.locationInfo.mapY = lng;


                    $ctrl.mapMarker.bindPopup("Moved to : " + lat[1] + ", " + lng[0] + ".");
                });
        }


    }

    var LocationInfoComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/location-info/partial-form.location-info.html',
        controller: LocationInfoComponentController,
        bindings:
            {
                locationInfo: '=',
            }

    };

    angular
        .module('tikonApp')
        .component('pfLocationInfo', LocationInfoComponent)

    LocationInfoComponentController.$inject = ['$scope', '$state', 'PersonInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'SelectorData', 'SelectorDataQuery'];


})();

